import React, { useState } from 'react';
import { Button, Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const EmailButton = () => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        navigator.clipboard.writeText('starkillermanagement@gmail.com');
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <>
            <Button
                onClick={handleClick}
                style={{
                    padding: 0,
                    cursor: "pointer",
                    width: '100%',
                    height: 'auto',
                    display: 'inline-flex',
                }}
                sx={{
                    "&:hover": {
                        cursor: "pointer",
                    },
                }}
            >
                <img
                    src="/images/email_gif.gif"
                    alt="Email"
                    style={{
                        width: '95%',
                        height: 'auto',
                        cursor: "inherit",
                    }}
                />
            </Button>
            <Snackbar
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message="Email copied to clipboard"
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </React.Fragment>
                }
            />
        </>
    );
};

export default EmailButton;
